<ion-content>
        <app-header [isParentPage]="true" [title]="'Home'"></app-header>
        <div class="loading-container" style="padding-top:15%;" *ngIf="!loaded">
            <ion-spinner></ion-spinner>
        </div>
          
            <div class="my-grid" style="padding-top:90px">
              <div style="display: flex; flex-direction: column; align-items: flex-end; width: 100%;">
              <span><b>Online Store</b></span>
              <span><b>Welcome {{user}}</b></span>
            </div>
                <div class="my-row">
                <div class="card-wrapper">
          <ng-container *ngFor="let item of menuItems">
            <div
              class="card-container"
              *ngIf="item.canAccess() && item.hasImage && item.label !== 'Logout'"
              (click)="navigateTo(item)"
            >
            <div class="card-image-wrapper"  style='background-color:#ffffff;' *ngIf="item.isAdmin && item.newImage != true">
                <img
                  class="card-image"
                  [src]="'./assets/nav-icons/Settings.png'"
                  alt="{{ item.label }}"
                  style="width:60px"
                />
              </div>

            
              <div class="card-image-wrapper" *ngIf="!item.isAdmin && item.newImage != true">
                <img
                  class="card-image"
                  [src]="item.customImg ?? './assets/placeholder.png'"
                  alt="{{ item.label }}"
                />
              </div>
               <div class="card-image-wrapper" *ngIf="item.newImage == true">
                <img
                  class="card-image"
                  [src]="item.customImg ?? './assets/placeholder.png'"
                  alt="{{ item.label }}"
                    style="width:55px"
                />
              </div>
              <div class="card-content">
                <div class="card-title">{{ item.label }}</div>
                <p *ngIf="item.description" class="card-description">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </ng-container>
        </div>
        </div>
      </div>  
</ion-content>